
const axios = require("axios")


class JsonRpc {
    
    constructor(url, methods, mocks) {

        this.useMocks = false
        this.url = url
        this.methods = methods
        this.mocks = mocks || {}
        for(let method in methods) {
            this[method] = function(...args) {
                if (this.useMocks === true || this.useMocks == "true") {
                    return this.mocks[method](args)
                } 
                return this.rpc(method, args)
            }
        }
    }

    rpc(method, ...args) {
        return axios({
            url: this.url,
            method: "post",
            data: {
                "jsonrpc": "2.0",
                "method": method,
                "params": args[0],
                "id": 1
              },
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json',
            }
        }).then(function (response) {
            if (response.data && response.data.error) {
              throw response.data.error
            }
            return response.data.result
        })
    } 

}


module.exports = JsonRpc